module.exports = __webpack_public_path__ + "f28dbd991c00b29e18884e508b81b959.png";